(function() {
	'use strict';
	angular.module('app.setup')
		.controller('updateWeeklyTargets', updateWeeklyTargets);

	updateWeeklyTargets.$inject = ['$scope', '$rootScope', '$state', '$timeout', '$filter', 'leanFilterService', 'leanTableService',
		'tableRenderService','tableService', 'updateTargetsService', 'storeService', 'navigationService'];

	function updateWeeklyTargets($scope, $rootScope, $state, $timeout, $filter, leanFilterService, leanTableService,
							  tableRenderService, tableService, updateTargetsService, storeService, navigationService) {
		var vm = this;
		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'update-weekly-targets';
		vm.initialData = {};
		var metricNoOfWeeks = {};
		var metricConfigByNdx = {};
		var defaultYear;
		var columns = [
			{
				'id': 'category',
				'display': 'Category',
				'width': 240,
				'renderer': tableRenderService.categoryRenderer,
				'sort': false
			},
			{
				'id': 'name',
				'display': 'Metric',
				'width': 240,
				'renderer': tableRenderService.metricRenderer,
				'sort': false
			},
			{
				'id': '',
				'display': '',
				'class': 'monthCellWithTarget headerCell',
				'renderer': tableRenderService.targetActualHeaderRenderer,
				'hideMenu': true,
				'disabledShowHide': true,
				'width': 150,
				'sort': false
			}
		];

		var defaultFilters  = [
			{
				'id': 'metric',
				'values': [$scope.filterService.leanDnaAllSelected],
				'isMandatory': true
			}, {
				'id': 'valueStreamWithPerf',
				'values': [0],
				'isMandatory': true
			}, {
				'id': 'fy',
				'values': [getFiscalYear()],
				'isMandatory': true
			}
		];

		vm.weeks = {};

		for (var weekNo = 0; weekNo <= 52; weekNo++) {
			var weekColumn = {};
			weekColumn.id = 'week' + weekNo;
			weekColumn.display = 'Week ' + weekNo;
			weekColumn.index = 0;
			weekColumn.sort = false;
			weekColumn.hideMenu = true;
			weekColumn.disabledShowHide = true;
			weekColumn.type = 'Weekly';
			if (weekColumn.class === undefined) {
				weekColumn.class = 'monthCell alignCenter veryLargeTitle';
			}
			if (weekColumn.renderer === undefined) {
				weekColumn.renderer = tableRenderService.targetActualRenderer;
			}
			weekColumn.width = 150;
			columns.push(weekColumn);
			vm.weeks[weekColumn.id] = {};
		}

		var reportSettingsId = undefined;
		$scope.subView = $scope.subView || {};
		$scope.subView.selectedView = 'Weekly';
		var view = $state.current.name === 'app.lean-projects.update-weekly-targets' ? 'projects-updatetargets' : 'updatetargets';
		vm.reportName = 'Update Weekly Targets';
		vm.showExcel = false;
		vm.initialLoad = true;

		var pinnedColumns = [];
		var rendererParams = {
			initialData: vm.initialData,
			monthIndexLessThanFactoryStartMonth: vm.monthIndexLessThanFactoryStartMonth
		};

		var extraParams = [{
			'name': 'targetPeriodType',
			'value': 'Weekly'
		}];

		init();

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: 'UpdateWeeklyTargetsNew',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			rendererParams: rendererParams,
			reportUrl: '{0}/UpdateTargetsReport',
			extraParams:extraParams,
			setColumnDefaults: true,
			hideSearch: true,
			showSaveButton: true,
			defaultFilters: defaultFilters,
			waitForFilters: true,
			reportSettingsScope: 'customer',
			hasMandatoryFilters: true,
			saveGridData: saveGridData
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.searchPlaceholderText = 'Search tasks...';
		vm.copyMetricTargets = copyMetricTargets;
		vm.saveGridData = saveGridData;

		var setFirstView = _.once(navigationService.setFirstView);

		function getData(params, extraParams, isFilterChanged) {
			return tableService.getData(params, extraParams).then(function (response) {
				if (response[0] && response[0].data) {
					if (!reportSettingsId) {
						setFirstView({'viewType': view}, reportSettingsName);
					}
					setHeaders(response[0].fiscalYear, response[0].fiscalWeekData, response[0].factoryDate);
					showLimitedMetricsMessage(response[0]);
					organizeData(response[0].data);
				}
				return response;
			});
		}

		function getMeta() {
			return meta;
		}

		$scope.tableService.setReportSettingsName(reportSettingsName);
		$scope.filterService.searchType = 'task';

		function init() {
			$scope.filterService.clearFilters();
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;
			siteFilter.masterObjectList = updateTargetsService.getAllowedSites();
			siteFilter.objectList = _.clone(siteFilter.masterObjectList);
			leanFilterService.useFactoryFilter = true;
			if (siteFilter.objectList && siteFilter.objectList.length) {
				defaultFilters.push({
					'id': 'factory',
					'values': [siteFilter.objectList[0].id],
					'isMandatory': true
				});
			}

			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);
			// Edit filter settings to prevent user from removing and change valuestream to single select
			var metricFilter = $scope.filterService.filterDefinitions.WeeklyTargetMetric;
			// XXX still removable by unselecting all items
			metricFilter.removable = false;
			var vsfilter = $scope.filterService.filterDefinitions.ValueStreamWithPerf;
			vsfilter.type = 'singleSelect';
			vsfilter.removable = false;
			var fiscalFilter = $scope.filterService.filterDefinitions.FiscalYearList;
			fiscalFilter.removable = false;

			// Add multi-select filters
			$scope.filterService.setMasterFilterList([
				metricFilter,
				$scope.filterService.filterDefinitions.MetricCategories,
				$scope.filterService.filterDefinitions.MetricTypes
			]);

			// Add single-select filters
			$scope.filterService.setMasterSingleSelectFilterList([
				siteFilter,
				vsfilter,
				fiscalFilter
			]);
		}

		function organizeData(data) {
			var resultSet = updateTargetsService.organizeData(data);
			vm.initialData = resultSet.initialData;
			metricNoOfWeeks = resultSet.metricNoOfWeeks;
			metricConfigByNdx = resultSet.metricConfigByNdx;
			rendererParams.initialData = vm.initialData;
			rendererParams.monthIndexLessThanFactoryStartMonth = vm.monthIndexLessThanFactoryStartMonth;
			vm.initialData['valueStreamWithPerf'] = $scope.filterService.getSelectedIds('valueStreamWithPerf')[0];
		}

		function getColumn(id, cols) {
			var column;
			if (typeof cols === 'undefined') {
				cols = columns;
			}
			column = _.find(cols, {
				'id': id
			});
			if (!column) {
				cols = pinnedColumns;
				column = _.find(cols, {
					'id': id
				});
			}
			return column;
		}

		function setHeaders(fiscalYear, fiscalWeekData, factoryDate) {
			var startDate = new Date(fiscalYear.startDate);
			var startMonth = startDate.getUTCMonth();
			var year = $scope.filterService.getSelectedIds('fy')[0];
			var monthIndexLessThanFactoryStartMonth = -1;
			// this shouldn't happen because the filter is not removable
			if (year === undefined) {
				year = new Date(fiscalYear.endDate).getUTCFullYear();
				// save so addFiscalYearCols() will have a value to use
				defaultYear = year;
			}

			angular.forEach(vm.weeks, function (week) {
				week.year = year;
			});

			for (var i = 0; i < fiscalWeekData.length; i++) {
				var column = getColumn('week' + i);
				if (factoryDate.factoryStartDate > fiscalWeekData[i].endDate) {
					monthIndexLessThanFactoryStartMonth = i;
				}
				column.display =  $filter('date')(fiscalWeekData[i].startDate, 'MMM d', 'UTC').toUpperCase() + ' - ' + $filter('date')(fiscalWeekData[i].endDate, 'MMM d', 'UTC').toUpperCase();
			}

			if (fiscalWeekData.length === 52) {
				var column = getColumn('week' + 52);
				if (column) {
					column = Object.assign(column, {
						disabled: true
					});
				}
			}
			vm.monthIndexLessThanFactoryStartMonth = monthIndexLessThanFactoryStartMonth;
		}

		function saveGridData() {
			var cellsUpdated = updateTargetsService.getUpdatedCells(vm.initialData, metricConfigByNdx, metricNoOfWeeks, vm.weeks, true);
			if (cellsUpdated.length > 0) {
				updateTargetsService.saveData(cellsUpdated, leanFilterService.getFactoryList()).then(function (isSuccess) {
					if (isSuccess) {
						$scope.$broadcast('reloadTable');
					}
				});
			} else {
				$rootScope.$emit('toast', {
					'message': 'No targets were updated',
					'success': false
				});
			}
		}

		function copyMetricTargets(metricName, metricNdx, periodType, isRatioTarget) {
			updateTargetsService.copyMetricTargets($scope, metricName, metricNdx, periodType, isRatioTarget, metricConfigByNdx, defaultYear, true);
		}

		function showLimitedMetricsMessage(response) {
			if (response.actualMetricsCount > response.currentMetricsCount) {
				$timeout(function () {
					$scope.clearToast();
					var message = 'Showing {0} out of {1} metrics. Please refine your filters.';
					$rootScope.$emit('toast', {
						message: String.format(message, response.currentMetricsCount, response.actualMetricsCount),
						success: false
					});
				}, 0);
			}
		}

		function getFiscalYear() {
			var firstFiscalMonth = globalConfig.customer.startingMonthOfFiscalYear + 1;
			var calendarMonth = new Date().getMonth() + 1;
			var calendarYear = new Date().getFullYear();
			var fiscalMonth = calendarMonth - firstFiscalMonth + 1;
			if (fiscalMonth < 1) {
				fiscalMonth += 12;
			}

			var fiscalYear = calendarYear;
			if (calendarMonth < firstFiscalMonth) {
				fiscalYear -= 1;
			}
			return fiscalYear;
		}
	}
})();
